<template>
<div class="main my">
  <my-head :user="user"></my-head>
  <div v-if="user.id" class="model-box my-model mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">我的订单</h3>
    </div>
    <van-row class="model-box__bd tac clear">
      <van-col span="6" class="mtw">
        <router-link :to="{ name: 'orderlistrepeat', params: { status: 'false'}}">
          <i class="my-model__icon iconfont">&#xe640;</i>
          <div class="fs1 mtn c6">全部</div>
        </router-link>
      </van-col>
      <van-col span="6" class="mtw">
        <router-link :to="{ name: 'orderlistrepeat', params: { status: 'created'}}">
          <i class="my-model__icon iconfont">&#xe65a;</i>
          <div class="fs1 mtn c6">待付款</div>
        </router-link>
      </van-col>
      <van-col span="6" class="mtw">
        <router-link :to="{ name: 'orderlistrepeat', params: { status: 'paid'}}">
          <i class="my-model__icon iconfont">&#xe618;</i>
          <div class="fs1 mtn c6">待评价</div>
        </router-link>
      </van-col>
      <van-col span="6" class="mtw">
        <router-link :to="{ name: 'orderlistrepeat', params: { status: 'refund'}}">
          <i class="my-model__icon iconfont">&#xe75a;</i>
          <div class="fs1 mtn c6">退款/售后</div>
        </router-link>
      </van-col>
    </van-row>
  </div>
  <div v-if="user.id" class="model-box my-model mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">我的预约</h3>
    </div>
    <van-row class="model-box__bd tac clear">
      <van-col span="6" class="mtw">
        <router-link :to="{ name: 'myreserved',params:{clubId:clubId,type:'clubPracticeCard'} }">
          <i class="my-model__icon iconfont">&#xef0e;</i>
          <div class="fs1 mtn c6">练球卡预约</div>
        </router-link>
      </van-col>
      <van-col span="6" class="mtw">
        <router-link :to="{ name: 'myreserved',params:{clubId:clubId,type:'clubPtCourse'} }">
          <i class="my-model__icon iconfont">&#xef4e;</i>
          <div class="fs1 mtn c6">私教课预约</div>
        </router-link>
      </van-col>
    </van-row>
  </div>
  <div v-if="user.id" class="model-box my-model mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">我的卡片</h3>
    </div>
    <van-row class="model-box__bd tac clear">
      <van-col span="6" class="mtw">
        <router-link :to="{ name: 'mycardlist',params:{clubId:clubId,cardType:'DAYS_CARD'} }">
          <i class="my-model__icon iconfont">&#xef0e;</i>
          <div class="fs1 mtn c6">练球卡</div>
        </router-link>
      </van-col>
      <van-col span="6" class="mtw">
        <router-link :to="{name: 'mycardlist',params:{clubId:clubId,cardType:'MONTH_CARD'} }">
          <i class="my-model__icon iconfont">&#xe70b;</i>
          <div class="fs1 mtn c6">包月卡</div>
        </router-link>
      </van-col>
    </van-row>
  </div>
  <div class="model-box my-model mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">我的服务</h3>
    </div>
    <van-row class="model-box__bd tac clear">
      <!-- 教练用户 / 俱乐部用户 -->
      <!-- <van-col v-if="show.club || show.service" span="6" class="mtw">
        <router-link :to="{ name: 'clubLamp'}">
          <i class="my-model__icon iconfont scan">&#xe698;</i>
          <div class="fs1 mtn c6">灯控系统</div>
        </router-link>
      </van-col> -->
      <van-col v-if="show.club || show.coach || show.service" span="6" class="mtw">
        <router-link :to="{ name: 'scancode'}">
          <i class="my-model__icon iconfont scan">&#xe607;</i>
          <div class="fs1 mtn c6">扫码核销</div>
        </router-link>
      </van-col>
      <van-col v-if="show.club || show.coach" span="6" class="mtw">
        <router-link :to="{ name: 'courselistmanage',params:{coachId:user.id,roles:userRoles}}">
          <i class="my-model__icon iconfont">&#xef5c;</i>
          <div class="fs1 mtn c6">课程管理</div>
        </router-link>
      </van-col>
      <van-col v-if="show.club ||show.coach" span="6" class="mtw">
        <router-link :to="{ name: 'manageorderlistrepeat' , params: { status: 'false'}}">
          <i class="my-model__icon iconfont">&#xe640;</i>
          <div class="fs1 mtn c6">订单管理</div>
        </router-link>
      </van-col>
      <van-col v-if="show.club ||show.coach" span="6" class="mtw">
        <router-link :to="{ name: 'wallet' }">
          <i class="my-model__icon iconfont">&#xef01;</i>
          <div class="fs1 mtn c6">账务管理</div>
        </router-link>
      </van-col>
      <van-col v-if="show.coach" span="6" class="mtw">
        <router-link :to="{ name: 'signcontract' }">
          <i class="my-model__icon iconfont">&#xef5c;</i>
          <div class="fs1 mtn c6">签约管理</div>
        </router-link>
      </van-col>
      <van-col v-if="show.club" span="6" class="mtw">
        <router-link :to="{ name: 'signcoach',params:{clubId:clubId} }">
          <i class="my-model__icon iconfont">&#xef5c;</i>
          <div class="fs1 mtn c6">签约管理</div>
        </router-link>
      </van-col>
      <van-col v-if="show.club || show.coach || show.service" span="6" class="mtw">
        <router-link :to="{ name: 'courseclassmanage' }">
          <i class="my-model__icon iconfont">&#xef5c;</i>
          <div class="fs1 mtn c6">预约管理</div>
        </router-link>
      </van-col>

      <!-- 普通用户 -->
      <van-col v-if="show.clubentry" span="6" class="mtw">
        <router-link :to="{ name: 'clubenteredlist'}">
          <i class="my-model__icon iconfont">&#xe64c;</i>
          <div class="fs1 mtn c6">俱乐部入驻</div>
        </router-link>
      </van-col>
      <van-col v-if="show.coachentry" span="6" class="mtw">
        <router-link :to="{ name: 'coachentry'}">
          <i class="my-model__icon iconfont">&#xef30;</i>
          <div class="fs1 mtn c6">申请教练认证</div>
        </router-link>
      </van-col>

      <!-- 默认显示 -->
      <van-col span="6" class="mtw">
        <router-link :to="{ name: 'venueinfo',params: {clubid: clubId}}">
          <i class="my-model__icon iconfont">&#xe819;</i>
          <div class="fs1 mtn c6">俱乐部说明</div>
        </router-link>
      </van-col>
      <van-col span="6" class="mtw">
        <router-link :to="{ name: 'venueinfo2',params: {clubid: clubId}}">
          <i class="my-model__icon iconfont">&#xe653;</i>
          <div class="fs1 mtn c6">预约说明</div>
        </router-link>
      </van-col>
      <van-col span="6" class="mtw">
        <router-link :to="{ name: 'venueinfo3',params: {clubid: clubId}}">
          <i class="my-model__icon iconfont">&#xe819;</i>
          <div class="fs1 mtn c6">私教等级说明</div>
        </router-link>
      </van-col>
      <van-col span="6" class="mtw">
        <router-link :to="{ name: 'help'}">
          <i class="my-model__icon iconfont help">&#xe608;</i>
          <div class="fs1 mtn c6">帮助与客服</div>
        </router-link>
      </van-col>

    </van-row>
  </div>
  <div v-if="user.id" class="logout-btn">
    <van-button @click="logout" size="large">退出</van-button>
  </div>
  <the-tabbar></the-tabbar>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import router from '@/router';
import {
  Button,
  Row,
  Col
} from 'vant';
import TheTabbar from '@/components/TheTabbar';
import TheCopyright from '@/components/TheCopyright';
import MyHead from '@/components/MyHead';

Vue.use(Button).use(Row).use(Col);

export default {
  name: 'My',
  components: {
    TheTabbar,
    TheCopyright,
    MyHead
  },
  data() {
    return {
      user: {}, // 当前用户信息
      show: {
        user: false, // 普通账户
        club: false, // 俱乐部
        coach: false, // 教练
        service:false, //客服
        wallet: false, // 账务管理入口
        clubentry: true, // 俱乐部入驻入口
        coachentry: true, // 教练认证入口
        signcontract: false, // 签约管理入口
      },
      clubId: sessionStorage.getItem("CLUBID"),
      userRoles:''  //用户角色
    }
  },
  beforeMount() {
    // 获取当前已登录用户信息
    this.$http.post('user/judgeLogin').then(res => {
      // console.log(res)
      if (res.data.code == 0) {
        this.user = res.data.value;
        if (this.user.roles.indexOf('ROLE_USER') !== -1) {
          // 普通用户角色操作
          this.show.user = true;
          this.show.clubentry = true;
          this.show.coachentry = true;
        }
        if (this.user.roles.indexOf('ROLE_CLUB_ADMIN') !== -1) {
          // 俱乐部用户角色
          this.show.club = true;
          this.show.clubentry = false;
          this.show.coachentry = false;
          this.userRoles = 'ROLE_CLUB_ADMIN'
        }
        if (this.user.roles.indexOf('ROLE_COACH') !== -1) {
          // 教练用户角色
          this.show.coach = true;
          this.show.clubentry = false;
          this.show.coachentry = false;
          this.userRoles = 'ROLE_COACH'
        }
        if (this.user.roles.indexOf('ROLE_CLUB_CS') !== -1) {
          // 客服
          this.show.service = true;
          this.show.clubentry = false;
          this.show.coachentry = false;
        }
      }
    });
  },
  methods: {
    logout: function() {
      // 退出登录
      Vue.cookie.delete('_ibl');
      // 返回首页
      router.push({
        path: 'venue'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.my-model {
    &__icon {
        font-size: 0.25rem;
        color: #666;
        width: 0.25rem;
        height: .25rem;
        display: block;
        overflow: hidden;
        margin: auto;
    }
    &__icon.scan{
      font-size: .2rem;
      padding-top: .04rem;
    }
    &__icon.help{
      font-size: .22rem;
    }
}
.logout-btn {
    padding: 0.15rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/My.vue